import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '@app/shared/base/base-component/base-component.component';
import { DisplayGroup } from '@app/shared/interfaces/display-group';
import { DropDownOption } from '@product/shared/models/GlobalInterfaces';

@Component({
  selector: 'app-display-group',
  templateUrl: './display-group.component.html',
  styleUrls: ['./display-group.component.less'],
})
export class DisplayGroupComponent extends BaseComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() mode: string;
  @Output() submitChanges: EventEmitter<any> = new EventEmitter();
  private _languageId: number = 0;
  public get languageId(): number {
    return this._languageId;
  }
  @Input()
  set languageId(value: number) {
    this._languageId = value;
    if (value != null && value > 0) {
      this.formGroup.disable();
      this.handleLanguageChange();
      this.formGroup.get('Label')?.enable();
    } else {
      if (this.record != null) {
        this.formGroup.get('Label')?.setValue(this.record?.Label);
      }
      this.formGroup.enable();
    }
  }
  record: any;
  languages: DropDownOption[] = [];
  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {}

  override submit() {
    this.submitChanges.emit();
  }

  recordLoaded(record: DisplayGroup) {
    if (record == null) {
      return;
    }
    this.propertiesArray.clear();
    record.DisplayProperties.forEach((prop) => {
      const propertiesArray = this.propertiesArray;
      const lineFormGroup = this.fb.group({
        Id: new FormControl(prop.Id),
        Title: new FormControl(prop.Title, [Validators.required]),
        Code: new FormControl(prop.Code, [Validators.required]),
        GroupId: new FormControl(prop.GroupId),
        DefaultValue: new FormControl(prop.DefaultValue),
      });
      propertiesArray.controls = [...propertiesArray.controls, lineFormGroup];
    });
  }

  cleanRecord(record: any) : any{
    return record;
  }

  beforeSubmit() {
    const group = this.formGroup.value as DisplayGroup;
    group.DisplayProperties = [];
    const controls = this.propertiesArray.controls as FormGroup[];
    controls.forEach((control) => {
      group.DisplayProperties.push(control.value);
    });
    group.DisplayProperties.forEach((prop) => {
      prop.Group = {
        Id: group.Id,
        Title: group.Title,
        DisplayProperties: [],
      };
    });
    return group;
  }
  afterSubmit(record: any) {}

  addPropertyLine() {
    const propertiesArray = this.propertiesArray;
    const lineFormGroup = this.fb.group({
      Id: new FormControl(0),
      Title: new FormControl('', [Validators.required]),
      Code: new FormControl('', [Validators.required]),
      GroupId: new FormControl(0),
      DefaultValue: new FormControl(null),
    });
    propertiesArray.controls = [...propertiesArray.controls, lineFormGroup];
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
    // const propertiesValue = propertiesArray.value as any[];
    // propertiesValue.push({Id:0,Title:'',Code:''})
  }
  get propertiesArray() {
    return this.formGroup.get('DisplayProperties') as FormArray;
  }
  submitTranslation() {
    if (this.record?.Id == null) {
      this.message.error(
        'Submitting translation is allowed only in the edit mode!'
      );
      return;
    }
  }
  valueChanged() {
    this.formGroup.markAsDirty();
    this.formGroup.markAsTouched();
  }
  handleLanguageChange() {}
  static controls(mode: string) {
    const controlsToReturn: any = {};
    if (mode === 'edit') {
      controlsToReturn['Id'] = [null, []];
    }
    controlsToReturn['Title'] = [null, [Validators.required]];
    controlsToReturn['DisplayProperties'] = new FormArray([]);
    return controlsToReturn;
  }
  deletePropertyLine(property: any) {
    // this.propertiesArray.controls;
    // console.log(
    //   'deletePropertyLine ~ this.propertiesArray.controls:',
    //   this.propertiesArray.controls
    // );
    const propertiesControls = this.propertiesArray.controls as FormGroup[];
    const propertiesValues = propertiesControls.map((x) => x.value);
    const index = propertiesValues.findIndex(
      (x) => x.Id === property.Id && x.Code === property.Code
    );
    this.propertiesArray.controls.splice(index, 1);
    this.propertiesArray.controls = [...this.propertiesArray.controls];
    this.valueChanged();
  }
}
